import * as _4 from 'lodash4';
import { IQuery, IQueryMediator } from 'core-ts-types';

import { ISection, ISectionType } from '../../interfaces/scheduler_interfaces';
import { ISectionsDatasource } from '../../views/sections/datasources/sections_datasource';
import { SectionSwapModel, ISectionSwapToFrom } from '../models/course_section_swap_model';
import { ITermCoursesDatasource } from '../../views/term_courses/datasources/term_courses_datasource';
import { ISectionSwapType } from '../interfaces/swap_section_interface';
import { ScheduledSectionsQuery } from '../../views/course_scheduler/queries/scheduled_sections_query';
import { MultiSectionServant } from '../../views/course_scheduler/servants/multi_section_servant';

interface ISectionSwapPreviewQuerySection extends ISection {
  _swap_type: string;
}

export class SectionSwapPreviewQuery implements IQuery {
  private _result: {
    from: ISectionSwapPreviewQuerySection[];
    to: ISectionSwapPreviewQuerySection[];
    disableSwap: boolean;
  };

  constructor(
    private QueryMediator: IQueryMediator,
    private ngSectionsDatasource: ISectionsDatasource,
    private ngMultiSectionServant: MultiSectionServant,
    private ngTermCoursesDatasource: ITermCoursesDatasource,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery
  ) {
    QueryMediator.registerQuery(this, ngSectionsDatasource, ngCourseSectionSwapModel);
  }

  clear() {
    this._result = {
      from: [],
      to: [],
      disableSwap: true
    };
  }
  run() {
    const allScheduledSections = this.ngScheduledSectionsQuery.result.list;
    let fromSections: ISection[] = _4.compact(
      _4.map(this.ngCourseSectionSwapModel.read().swap_from_section_ids, (item: ISectionSwapToFrom) =>
        _4.find(allScheduledSections, { id: item.id })
      )
    );
    let toSections: ISection[] = _4.compact(
      _4.map(this.ngCourseSectionSwapModel.read().swap_to_section_ids, (item: ISectionSwapToFrom) => {
        return _4.find(this.ngSectionsDatasource.metasource().derived(), { id: item.id }) as ISection;
      })
    );

    fromSections = _4.sortBy(fromSections, (item) => _4.get(item, '_section_type.cd'));
    toSections = _4.sortBy(toSections, (item) => _4.get(item, '_section_type.cd'));

    const toSectionIds = _4.sortBy(_4.compact(_4.map(toSections, (section) => _4.get(section, 'id'))));
    const fromSectionIds = _4.sortBy(_4.compact(_4.map(fromSections, (section) => _4.get(section, 'id'))));
    const isSwaapingSameSections = _4.isEqual(toSectionIds, fromSectionIds);
    let disableSwap: boolean = false;

    if (this.ngCourseSectionSwapModel.read().isMultiSection && !_4.isEmpty(_4.first(toSections))) {
      const course = _4.first(toSections)._course;
      const session = _4.get(_4.first(toSections)._section_type, 'session', '');
      const requiredSectionTypeIds = _4.map(
        _4.filter(
          course._section_types,
          (sectionType: ISectionType) =>
            sectionType.is_active && sectionType.session === session && sectionType.is_required
        ),
        'id'
      );
      const toSectionTypeIds = _4.sortBy(
        _4.compact(_4.map(toSections, (section) => _4.get(section, '_section_type.id')))
      );
      disableSwap = !!_4.size(_4.difference(requiredSectionTypeIds, toSectionTypeIds)) || isSwaapingSameSections;
    } else {
      disableSwap = toSections.length < 1 || isSwaapingSameSections;
    }

    const from = fromSections.map((fromSection) => ({ ...fromSection, _swap_type: 'from' }));
    const to = toSections.map((toSection) => ({ ...toSection, _swap_type: 'to' }));

    this._result = {
      from,
      to,
      disableSwap
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngSectionSwapPreviewSwapQuery', SectionSwapPreviewQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/queries/section_swap_preview_query.ts